{
  "fr": {
    "login": "Connexion",
    "doLogin": "Se connecter",
    "forgotPassword?": "Mot de passe oublié ?",
    "forgotPassword": "Mot de passe oublié",
    "loginTitle": "Accéder à votre compte",
    "rememberMe": "Se souvenir de moi",
    "registerTitle": "Créez votre compte",
    "register": "S'inscrire",
    "validate": "Valider",
    "lastName": "Nom",
    "firstName": "Prénom",
    "emailAddress": "Adresse mail",
    "address": "Adresse",
    "streetNumber": "Numéro et nom de rue",
    "zipCode": "Code Postal",
    "city": "Ville",
    "country": "Pays",
    "email": "Email",
    "addedBy": "Ajouté par",
    "companyName": "Nom de l'entreprise",
    "businessLine": "Secteur d'activité",
    "SIREN": "SIREN",
    "SIRET": "SIRET",
    "NIC": "NIC",
    "clientId": "ID du client",
    "exportAllCompanyData": "Exporter toutes les données de l'entreprise",
    "RCS": "R.C.S",
    "publish": "Publié",
    "userEmail": "Adresse email de votre compte utilisateur",
    "paginationNumberTitle": "Résultats présentés",
    "unregisteredCompany": "Non inscrite au RCS - aucune donnée disponible sur cette entreprise",
    "newlyRadiatedCompany": "Entreprise radiée le {date}, vous ne pouvez plus recevoir d'alertes",
    "radiatedCompany": "Entreprise radiée le {date}, vous ne pouvez pas la mettre sous surveillance",
    "create": "Créer",
    "youHaveToMonitor": "Vous devez poser une surveillance pour avoir accès a ces informations.",
    "setUpMonitoringBilling": "Vous vous apprêtez à mettre une entreprise sous surveillance, votre facturation pourra être affectée.",
    "setUpMonitoringLevel": "Nouvelle mise sous surveillance",
    "confirmAction": "Confirmez vous cette action?",
    "documentsInSynchronization": "Les documents sont en cours d'importation. Cette opération peut prendre de quelques minutes à plusieurs heures.",
    "noDocumentsAvailable": "Aucun document disponible.",
    "importationError": "Une erreur s'est produite sur la récupération d'un ou de plusieurs documents, veuillez contacter le support Infogreffe.",
    "fileNumber": "N° Dossier",
    "ok": "J'ai compris",
    "noEditable": "Non modifiable",
    "mandatoryField": "Champs obligatoires",
    "civility": {
      "title": "Civilité",
      "mr": "Mr",
      "mme": "Mme"
    },
    "documentTypes": {
      "kbis": "Extrait KBIS",
      "actes": "Actes et statuts",
      "bilan": "Bilans",
      "beneficiary": "Bénéficiaires effectifs"
    },
    "packageLabel": "Libellé du package",
    "importHistory": "Historique",
    "chooseMonitoringLevel": "Surveillance",
    "title": "Titre",
    "noAlerts": "Aucune alerte",
    "summary": "Résumé",
    "content": "Contenu",
    "delete": "Supprimer",
    "retrievalInProgress": "En cours de récupération",
    "retrievalInError": "Récupération du document impossible",
    "visualize": "Visualiser",
    "visualizeAgain": "Visualiser à nouveau",
    "documents": "Documents",
    "noDocuments": "Aucun document trouvé",
    "prerequisites": "Pré-requis",
    "action": "Action",
    "status": "Statut",
    "upload": {
      "chooseFile": "Choisir un fichier",
      "chooseFileImage": "Choisir une image",
      "noFile": "Aucun fichier sélectionner",
      "selectFile": "Séléctionnez un fichier d'import",
      "downloadModalCsv": "Télécharger le modèle de fichier .csv"
    },
    "import": "Importer",
    "noResults": "Aucun résultat.",
    "importCompanies": {
      "title": "Importer une liste d'entreprises",
      "send": "Importer la liste d'entreprises",
      "onlyRcs": "La mise sous surveillance d'entités non inscrites au RCS est considérée comme inactive (aucun document pour ces entreprise ne peut être visionné).",
      "onlyAvailableDocument": "La mise sous surveillance pour les agents commerciaux et entrepreneurs individuels est limitée aux documents disponibles.",
      "onlyCsv": "Le fichier doit être un CSV et ne doit pas dépasser 4mb",
      "radiation": "Radiation",
      "format": {
        "title": "Votre fichier CSV doit contenir les colonnes suivantes : ",
        "content": "Numéro de SIREN; Niveau de surveillance; Libellé de surveillance; Référence Interne; Nom et prénom du gestionnaire"
      },
      "columnOrder": "L’ordre des colonnes doit être le même que l’ordre dans lequel elles sont listées.",
      "sirenAtLeastNineNumber": "Le numéro SIREN doit contenir 9 chiffres (dans certains cas 6 chiffres)",
      "monitoringInfos": {
        "title": "Pour signifier qu’on lève la surveillance, le champ ",
        "0": "Niveau de surveillance",
        "1": " doit être égal à \"0\" et son libellé à \"Archivé\""
      },
      "theField": "Le champ",
      "canBeEmpty": "peut être vide."
    },
    "searchMenu": {
      "recap": "Récapitulatif entreprise",
      "people": "Récapitulatif personnes",
      "documents": "Documents officiels",
      "alerts": "Alertes",
      "note": "Notes"
    },
    "actionTypes": {
      "_0": "Aucune action",
      "_1": "Package non trouvé",
      "_2": "Utilisateur non trouvé",
      "_3": "Surveillance déjà posée",
      "_4": "Service KYC inaccessible",
      "_5": "SIREN Inconnu",
      "_6": "Rejeté",
      "_10": "En cours",
      "_11": "Archivé",
      "_12": "Ajouté",
      "_13": "Mis a jour",
      "_14": "Inactive"
    },
    "404": "404 Not Found",
    "manual": "Ajout manuel",
    "group": "Ajout par import",
    "user": "Utilisateur",
    "event": "Événement",
    "loginFailed": "Vos identifiants sont incorrects ou bien un trop grand nombre de tentatives a été effectué. Veuillez réessayer ultérieurement.",
    "accountUnactive": "Votre compte client a été désactivé, veuillez contacter le support d'Infogreffe.",
    "invalidCredentials": "Votre email n'est pas reconnu, veuillez vous renseigner auprès de l'utilisateur principal du compte abonné afin de créer votre compte",
    "welcomeToKYC": "Bienvenue sur Infogreffe KYC",
    "setPassword": "Pour continuer, veuillez configurer votre nouveau mot de passe.",
    "pleaseSetPassword": "Veuillez configurer votre nouveau mot de passe.",
    "newPassword": "Nouveau mot de passe",
    "newPasswordConfirmation": "Confirmation du nouveau mot de passe",
    "password": "Mot de passe",
    "confirm": "Confirmer",
    "confirmPassword": "Confirmation du mot de passe",
    "passwordShouldContains": "Votre mot de passe doit contenir :",
    "passChecker": {
      "numberOfCharacters": "{numberOfCharacters} caractères minimum",
      "oneSpecialCharacter": "1 caractère spécial",
      "oneNumber": "1 chiffre",
      "oneUppercase": "1 majuscule",
      "oneLowercase": "1 minuscule"
    },
    "archive": "Archiver",
    "unarchive": "Modifier ou Désarchiver",
    "published": "Publié",
    "unpublished": "Non-publié",
    "keyNumbers": "Chiffres clés",
    "noKeyNumbers": "Aucun chiffres clés",
    "result": "Résultat",
    "results": "Résultats",
    "ca": "Chiffre d'affaires",
    "id": "ID",
    "alertDetails": "Détail de l'alerte",
    "passDontMatch": "Les mots de passe ne correspondent pas.",
    "invalidEmail": "Veuillez rentrer un e-mail valide.",
    "anErrorOccured": "Une erreur est survenue, veuillez réessayer",
    "aDocapostErrorOccured": "Une erreur est survenue, veuillez réessayer",
    "hello": "Bonjour",
    "welcomeHome": "bienvenue sur votre tableau de bord",
    "supervisedCompany": "Entreprises surveillées",
    "inTotal": "dans le portefeuille du compte",
    "inWallet": "dans votre portefeuille",
    "managedByYou": "dont vous êtes le gestionnaire",
    "monitoringLevel": "Niveau de surveillance",
    "addMonitoringLevel": "Ajouter un niveau de surveillance",
    "addPackage": "Ajouter un package",
    "editPackage": "Editer un package",
    "manageAccounts": "Gestion des comptes",
    "managePackages": "Gestion des packages",
    "manageArticles": "Gestion des articles",
    "addVideo": "Ajouter une vidéo YouTube",
    "addYoutubeVideo": "Lien YouTube",
    "articles": "Articles",
    "phone": "Téléphone",
    "subject": "Sujet",
    "send": "Envoyer",
    "messageSent": "Message envoyé",
    "messageNotSent": "Votre message n'a pas été envoyé",
    "message": "Message",
    "addArticle": "Ajouter un article",
    "addManager": "Ajouter un gestionnaire",
    "chooseManager": "Choisir un gestionnaire",
    "chooseNewManager": "Choisir un nouveau gestionnaire",
    "addCompany": "Ajouter une entreprise",
    "goToWallet": "Accéder au portefeuille",
    "addCompanyToInfogreffe": "Ajouter une entreprise depuis la base de données Infogreffe",
    "company": "Société",
    "addCompanyToInfogreffeSubtitle": "Accédez à la liste d’entreprises correspondant à votre recherche et mettez sous surveillances des entreprises pour les ajouter à votre portefeuille.",
    "or": "ou",
    "decision": "Type/Décision",
    "kbisUpdates": "Modifications dans la rubrique",
    "filters": "Filtres",
    "importCompanyList": "importez une liste d'entreprises depuis un fichier",
    "importCompany": "Importer une liste de sociétés",
    "mentionedKBIS": "Personnes mentionnées au Kbis",
    "beneficiariesRegistered": "Bénéficiaire(s) effectif(s) au registre",
    "capitalHolder": "Détenteurs du capital issus des statuts",
    "recentAlerts": "Vos 5 dernières alertes",
    "allAlerts": "Toutes les alertes",
    "myAlerts": "Alertes",
    "strengthened": "Renforcé",
    "changes": "Modifications",
    "editMonitoringLevel": "Modification des informations de surveillance",
    "changeMonitoringBilling": "Si vous avez réalisé un changement de niveau de surveillance, votre facturation pourra être affectée.",
    "archiveTitle": "Archivage d'une entreprise",
    "archiveMessage": "Vous vous apprêtez à archiver une société de votre portefeuille. La surveillance s'arretera et son niveau passera à 0. Vous ne serez plus facturés pour cette entreprise.",
    "caution": "Attention !",
    "change": "Modifier",
    "addInternalId": "Insérer une référence interne",
    "changeInfo": "Modifier les informations",
    "completeMonitoring": "Infogreffe dispose des données nécessaires pour permettre une surveillance complète.",
    "partialMonitoring": "Infogreffe ne dispose pas des données nécessaires pour permettre une surveillance complète.",
    "read": "Lu",
    "unread": "Non lu",
    "unset": "--",
    "date": "Date",
    "alertDate": "Date de l'alerte",
    "radiation": "Radiation",
    "companyLabel": "Dénomination",
    "confidentiality": "Confidentialité",
    "internalId": "Référence interne",
    "concernedDocuments": "Document concerné",
    "readUnread": "Lu/Non lu",
    "readMore": "Lire la suite",
    "home": "Accueil",
    "mainUser": "Utilisateur principal",
    "secondaryUser": "Utilisateur secondaire",
    "offerAPI": "Offre API",
    "legalInfo": "Mentions légales",
    "cgv": "CGV-CGU",
    "cookiesPolicy": "Politique cookies",
    "monitoringInfos": "Informations de surveillance",
    "contact": "Contact",
    "contactUs": "Contactez-nous",
    "closureDate": "Date de clôture",
    "generalInfos": "Informations générales",
    "copyright": "2020 Infogreffe",
    "news": "Actualités",
    "lastNews": "Dernières actualités",
    "allNews": "Toutes les actualités",
    "all": "Toutes",
    "allMonitoring": "Toutes les surveillances",
    "allManager": "Tous les gestionnaires",
    "allStatutes": "Tous les status",
    "dashboard": "Tableau de bord",
    "myWallet": "Portefeuille",
    "settings": "Compte",
    "registryCommercialCourtOf": "Greffe du Tribunal de Commerce de",
    "logout": "Déconnexion",
    "save": "Enregistrer",
    "adminTitle": "Portail admin",
    "subscribersAccounts": "Comptes abonnés",
    "subscriberAccounts": "Compte auquel s'applique le package",
    "addSubscriberAccount": "Ajouter un compte abonné",
    "edit": "Editer",
    "editSubscriberAccount": "Editer un compte abonné",
    "headOffice": "Siège social",
    "activity": "Activité",
    "manager": "Gestionnaire",
    "price": "Prix",
    "registration": "Immatriculation",
    "setUpMonitor": "Mettre sous surveillance",
    "setUpNewMonitor": "Mettre sous surveillance",
    "setUpNewMonitorUnregistered": "Poser une surveillance à niveau 0",
    "radieSevenYear": "Dossié radié depuis plus de 7 ans: Aucune information disponible",
    "monitoring": "Surveillance",
    "seeCompany": "Voir l'entreprise",
    "unregisteredAt": "Radiée le",
    "isNotRcs": "Non-immatriculée au RCS",
    "searchInProgress": "Recherche en cours",
    "noResult": "Auncun résultat",
    "research": "Recherche",
    "search": "Rechercher",
    "noCompanies": "Aucune société trouvée",
    "noUser": "Aucun utilisateur trouvé",
    "companySearchPlaceholder": "Dénomination d'entreprise, nom de dirigeant, numéro SIREN ou SIRET",
    "addSecondaryUser": "Ajout d'un utilisateur",
    "fullName": "Nom complet",
    "createUserInfos": "L’adresse email sera utilisée pour que l’utilisateur valide son compte afin d'utiliser les fonctionnalités du portail.",
    "accountSettingsInfoMonitoring": "Une surveillance désactivée pourra être réactivée à tout moment par l’utilsateur principal",
    "addUser": "Ajouter l'utilisateur",
    "addAUser": "Ajouter un utilisateur",
    "cancel": "Annuler",
    "duplicatedEmail": "Cet email est déjà utilisé",
    "usersAccount": "Utilisateurs du compte",
    "modifyAccountName": "Modifier le compte",
    "annualAccounts": "Comptes annuels",
    "type": "Type",
    "EmailSend": "Un email vous a été envoyé.",
    "areYouSureToExit": "Voulez-vous changer de page ? Vous perdrez les données de votre saisie actuelle.",
    "backHome": "Revenir à l'accueil",
    "linkExpired": "Le lien auquel vous essayez d'accéder a expiré.",
    "extractKbis": "Extrait Kbis",
    "creation": "Création",
    "disable": "Désactivation",
    "unspecifiedActivity": "Activité non-renseignée",
    "unspecified": "Non mentionné",
    "unspecifiedF": "Non mentionnée",
    "brand": "Enseigne",
    "commercialName": "Nom commercial",
    "createUserFirstNamePlaceholder": "Indiquer le prénom de l’utilisateur",
    "createUserLastNamePlaceholder": "Indiquer le nom de l’utilisateur",
    "createUserNamePlaceholder": "Indiquer le prénom et le nom de l’utilisateur",
    "createUserEmailPlaceholder": "Indiquer l’adresse email de l’utilisateur",
    "accountSettings": "Paramètres du compte",
    "usersManagement": "Gestion des utilisateurs",
    "billing": "Commandes et facturations",
    "add": "Ajouter",
    "about": "À propos",
    "accountPicture": "Logo du compte",
    "importPicture": "Importer une image",
    "pictureRequirement": "Taille maximum : 3MB",
    "pictureFormat": "Formats accéptés : jpg, jpeg ou png",
    "accountName": "Nom du compte",
    "creationDate": "Date de création",
    "kbisDate": "Date de fraîcheur",
    "depositDate": "Date de dépôt",
    "statusDate": "Date de l'acte",
    "packageDocuments": "Package de documents",
    "disableDate": "Date de désactivation",
    "priceWithVAT": "Prix HT",
    "vat": "HT",
    "perMonth": "/mois",
    "package": "Package",
    "identityFolder": "Dossier idendité",
    "physicalPeopleBilling": "Tarification Réduite / Personne Physique",
    "priorityLevel": "Niveau de priorité",
    "addLevelMonitoring": "Ajout d'un niveau de surveillance",
    "editLevelMonitoring": "Editer un niveau de surveillance",
    "choosePriorityLevel": "Choisir un niveau de priorité",
    "labelLevelSupervision": "Libellé du niveau de surveillance",
    "packageAccess": {
      "docKbis": "- données et docs KBIS RBE Statuts et alertes sur ces éléments"
    },
    "notAvailable": "Non disponible",
    "noBilling": "Hors Tarification",
    "legalPersonBilling": "Tarification Générale / Personne Morale",
    "enterprise(s)": "Entreprise(s)",
    "newMonitoring": "Nouvelles surveillances",
    "updatedMonitoring": "Surveillances actualisées",
    "renewedMonitoring": "Surveillances reconduites",
    "globalPrice": "Prix global",
    "total": "Total",
    "period": "Période",
    "statut": "Statut",
    "confidential": "Confidentiel",
    "underMontoringOn": "Mis en surveillance le",
    "declarationBeneficialOwners": "Déclaration des bénéficiaires effectifs",
    "actsAndStatutes": "Actes et statuts",
    "suggestLabel": "Indiquez un libellé",
    "suggestPackageName": "Indiquez un nom de package",
    "suggestPackagePrice": "Indiquez un prix de package",
    "suggestPackageCode": "Indiquez un code de package",
    "packageName": "Nom",
    "packagePrice": "Prix",
    "packagePriceMoralPerson": "Prix Personne Morale",
    "packagePricePhysicPerson": "Prix Personne Physique",
    "packageCode": "Code",
    "invisiblePackage": "Package invisible",
    "chooseSubscribedAccount": "Tous les comptes abonnés",
    "reactivateMonitoringLevel": "> Réactiver le niveau de surveillance",
    "Disable": "Désactiver",
    "disabled": "Désactivé",
    "DisableUser": "Désactivation de l'utilisateur",
    "EnableUser": "Réactivation de l'utilisateur",
    "exportAlerts": "Exporter la liste des alertes",
    "exportWallet": "Exporter le portefeuille",
    "resetFilters": "Réinitialiser les filtres",
    "companiesSearch": "Dénomination, SIREN ...",
    "usersSearch": "Nom, Prénom, Email, Type...",
    "cautionEnableAccount": "Attention, vous êtes en train de réactiver ce compte utilisateur.",
    "chooseUserReplacement": "Choisissez un nouveau gestionnaire pour les entreprises de cet utilisateur.",
    "disableMonitoringLevel": "> Désactiver le niveau de surveillance",
    "disablePackage": "> Rendre invisible le package",
    "noExecutives": "Aucun dirigeant trouvé",
    "executive": "Dirigeant",
    "disableUser": "> Désactiver l'utilisateur",
    "enableUser": "> Réactiver l'utilisateur",
    "portalAdmin": "Portail admin",
    "disableMonitoringInfos": "Vous ne pouvez désactiver un niveau de surveillance que si ce dernier n'est plus utilisé pour surveiller des entreprises",
    "disablePackageInfos": "Vous ne pouvez désactiver un niveau de surveillance que si ce dernier n'est plus utilisé pour surveiller des entreprises",
    "cautionDisableMonitoringLevel": "Vous êtes sur le point de désactiver ce niveau de surveillance",
    "cautionDisablePackage": "Vous êtes sur le point de désactiver ce package",
    "userInfosDisable": "Un utilisateur désactivé ne pourra plus se connecter à l’interface. Il pourra être réactivé à tout moment par l’utilsateur principal",
    "editSecondaryUser": "Editer un utilisateur",
    "paymentAtMonitoringInfo": "Paiement à la mise en surveillance d'une entreprise",
    "packageSelectMonitoringToCreate": "Veuillez vous assurer qu'un libellé du niveau de surveillance a bien été choisi et que vous avez choisi un package",
    "associatedPackage": "Package associés",
    "priceMin": "Prix min",
    "priceMax": "Prix max",
    "packageGiveAccessInfo": "Ce package vous donne accès à :",
    "select": "Sélectionné",
    "choose": "Choisir",
    "headerSearchAddCompany": "Ajouter une entreprise depuis la base de données Infogreffe",
    "companiesMatch": "entreprises correspondent à votre recherche.",
    "include": "Dont",
    "rcsCompanies": "entreprises immatriculées au Registre du Commerce et des Sociétés",
    "notRcsCompanies": "entreprises non immatriculées au RCS et ",
    "radieRcsCompanies": "entreprises radiées du RCS",
    "executivesMatch": "dirigeants correspondent à votre recherche.",
    "secondaryEtablishment": "Établissements",
    "noEtablishment": "Aucun établissements",
    "activityNAF": "Activité (code NAF)",
    "legalForm": "Forme juridique",
    "simplifiedStockCompany": "Société par actions simplifiée",
    "immatriculationDate": "Date d'immatriculation",
    "maximumCharacter": "Votre note dépasse le nombre de caractères autorisés",
    "clickToCreateMemo": "Cliquer pour commencer à rédiger une nouvelle note",
    "accountConfidentiality": "Comptes déposés avec déclaration de confidentialité",
    "accountResultConfidentiality": "Comptes résultats déposés avec déclaration de confidentialité",
    "secondaryEtablishmentStatusCode": {
      "_1": "Comptes annuels non déposés",
      "_2": "Commandes possibles si comptes annuels déposés mais payants",
      "_3": "Report de l'Assemblé Générale"
    },
    "etablishmentType": {
      "_0": "Siège social",
      "_1": "Étab. principal",
      "_2": "Étab. secondaire"
    },
    "notRequiredToDeposit": {
      "NON_TENU_DE_DEPOSER": "Société non tenue de déposer ses comptes annuels au Greffe",
      "GIE": "Les GIE ne sont pas tenus de déposer leurs comptes au Greffe",
      "PERSONNE_PHYSIQUE": "Société en nom collectif non tenue au dépôt des comptes annuels, tous les associes n'étant pas des personnes morales",
      "COMMERCANTS": "Les entreprises en nom personnel ne sont pas tenues de déposer leurs comptes au Greffe",
      "EIRL": "EIRL",
      "FJ_ETRANGERE": "Forme juridique étrangère",
      "STE_RECEMMENT_IMMAT": "Société récemment immatriculée, Comptes annuels non déposes",
      "ANCIEN_DOSSIER": "Dossier radie depuis plus de 7 ans (aucune information disponible)"
    },
    "companies": "Entreprises",
    "totalCompanies": "Total",
    "totalCompaniesInactive": "Inactives",
    "totalCompaniesArchived": "Archivées",
    "totalCompaniesFail": "Rejetées",
    "totalCompaniesAdded": "Ajoutées",
    "totalCompaniesPending": "En traitement",
    "totalCompaniesUpdated": "Mises à jour",
    "sirenPlaceHolder": "Insérer un SIREN valide",
    "clientIdPlaceHolder": "Insérer un ID",
    "downloadTutorial": "Guide utilisateur",
    "agree": "Poursuivre la navigation",
    "taxe": "Taxe",
    "chooseATaxe": "Choisir une taxe",
    "cookies": {
      "title": "Politique d'utilisation des cookies",
      "popupTitle": "Politique des cookies",
      "popupText": "Nous n’utilisons que des cookies et autres technologies aux fins d’assurer le bon fonctionnement du site et réaliser des statistiques de visites. Cliquez sur \"Accepter tout\" pour donner votre accord, \"Refuser tout\" pour laisser les cookies inactifs, ou sur \"Gérer les cookies\" pour personnaliser vos choix.",
      "popupLink": "En savoir plus sur notre politique d’utilisation des cookies.",
      "acceptAll": "Accepter tout",
      "refuseAll": "Refuser tout",
      "saveCookiesPreferences": "Enregistrer mes choix",
      "manageCookies": "Gérer les cookies",
      "mandatory": "Nécessaires",
      "optional": "Statistiques",
      "name": "Nom",
      "source": "Source",
      "expirationDate": "Date d'expiration",
      "description": "Description de la finalité des cookies",
      "alwaysOn": "Toujours actifs",
      "agree": "Accepter",
      "refuse": "Refuser",
      "cookiesManagement": "Gestion des cookies"
    },
    "rgpd": {
      "title": "Charte RGPD",
      "modalTitle": "Consentement aux CGUV et à la charte RGPD",
      "textAgreement": "« En cochant cette case, j'accepte et je reconnais avoir pris connaissance des Informations fournies à l'Utilisateur au titre de ses données à caractère personnel (en application du règlement UE 2016/679 du 27 avril 2016 (RGPD) et de la loi n°78-17 du 6 janvier 1978) (« <a href='/rgpd' target='_blank'>Charte RGPD</a> »).»",
      "cguvTextAgreement": "« En cochant cette case, j'accepte et je reconnais avoir pris connaissance des <a href='/cgv' target='_blank'>Conditions Générales d'Utilisation et de vente du GIE Infogreffe</a>. »",
      "continue": "Poursuivre la navigation"
    },
    "emailsConfiguration": "Configuration des emails",
    "emailsFrequency": "Fréquence de réception",
    "everyDays": "Tous les jours",
    "onceAWeek": "Une fois par semaine",
    "emailsActivation": "Activer les notifications par email des alertes liées aux surveillances",
    "nextRenewalDate": "Date de reconduction",
    "defaultMonitoringLevel": "Niveau de surveillance par défaut",
    "chooseADefaultMonitoringLevel": "Choisir une niveau de surveillance par défaut",
    "selectAManager": "Sélectionner un manager",
    "filterByManager": "Filtrer par gestionnaire",
    "businessIntelligence": "Statistiques",
    "users": "utilisateur | utilisateurs",
    "monitorings": "Surveillances",
    "searchByClientName": "Rechercher par nom de client",
    "noClient": "Aucun client trouvé",
    "previous": "Précédent",
    "filterByPeriod": "Filtrer par période",
    "userActivities": "Activité du compte: {user}",
    "totalMonitoring": "Nombre total de surveillances",
    "usersTotalNumber": "Nombre total de clients",
    "monitoringsTotalNumber": "Nombre total de surveillances",
    "clientName": "Nom du client",
    "usersNumber": "Nombre d'utilisateurs",
    "last2Years": "Les 2 dernières années",
    "actifUserAccounts": "Comptes clients actifs",
    "monitoringsNumber": "Nombre de surveillances",
    "totalSpent": "Dépenses totales",
    "lastConnection": "Dernière connexion",
    "lastMonitoring": "Dernière surveillance",
    "lastMonth": "Le mois dernier",
    "last6Months": "Les 6 derniers mois",
    "currentYear": "Les 12 derniers mois",
    "alertCount": "Nombre total d'alertes",
    "deleteUser": "> Supprimer l'utilisateur",
    "sendBackAccountConfirmation": "> Renvoyer le lien de confirmation de compte",
    "confirmationEmailSent": "Email envoyé !",
    "userMustBeDisabled": "L'utilisateur doit d'abord être désactivé afin de transférer son portefeuille vers un autre gestionnaire",
    "choosePaginationNumber": "Nombre de résultats par page",
    "month": "mois",
    "year": "année",
    "mainUserShouldReceiveAlerts": "Utilisateur principal en copie",
    "exportData": "Exporter les données",
    "accessToBeneficiaries": "Accès aux Bénéficiaires Effectifs",
    "accessToConfidentialData": "Accès aux Bilans Confidentiels",
    "activatedAccount": "Compte Activé",
    "forcePasswordChangeTitle": "Changement de mot de passe",
    "forcePasswordChangeSubtitle": "Conformément aux recommandations CNIL, votre mot de passe doit évoluer pour en améliorer la sécurité. Nous vous invitons dès maintenant à changer votre mot de passe.",
    "pleaseFillInAllFields": "Veuillez remplir tous les champs.",
    "passwordNotCompliant": "Votre mot de passe doit comporter au moins {numberOfCharacters} caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.",
    "passwordShouldBeDifferentFromOldOne": "Veuillez renseigner un mot de passe différent de l’ancien."
  },
  "en": {}
}
